import { Box, Checkbox, Stack } from '@mui/material'
import React from 'react'
import { css, keyframes } from "@emotion/react";

import CheckIcon from '@mui/icons-material/Check';

import { Color, FontStyle } from '../constants'

export const tease = () => keyframes`
    0% {
        transform: scale(1);
    }
    10% {
        transform: scale(1.025);
    }
    100% {
        transform: scale(1);
    }
`;
const styles = {
    container: {
        // backgroundColor: Color.primary,
        border: `1px solid ${Color.borderGray}`,
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '0.38em',
        padding: '0.69rem 16px',
        cursor: 'pointer',
        userSelect: 'none',
        textAlign: 'center',
        backgroundColor: 'white',
        width: '100%',
        '&:hover': {
            animation: `${tease()} 0.3s ease-in-out 0s`,
        },
    },
    containerDisabled: {
        color: 'rgb(122, 122, 104)',
        cursor: '',
        '&:hover': {
        },
    },
    selected: {
        backgroundColor: Color.primary,
    },
    text: {
        ...FontStyle.body,
        fontSize: '16px',
        transition: 'all 0.3s ease-in-out 0s',
        // transform: 'translateX(-0.7rem)',
    },
    textStack: {
        ...FontStyle.body,
        fontSize: '16px',
        transition: 'all 0.3s ease-in-out 0s',
        width: '100%',
        paddingLeft: '1.5rem',
        // transform: 'translateX(-0.7rem)',
    },
    icon: {
        position: 'absolute',
        left: '0.75rem',
        transition: 'all 0.3s cubic-bezier(0.8, 1.64, 0.6, 1) 0s',
        opacity: 0,
        transform: 'translateY(-50%)'
    },
    iconSelected: {
        opacity: 1,
        transform: 'scale(1)',
    },

    title: {
        ...FontStyle.headingBody,
        width: '100%',
        textAlign: 'left',
    },
    bar: {
        width: '100%',
        height: '1px',
        backgroundColor: '#000',
        opacity: 0.2,
    },
    greenHover: {
        '&:hover': {
            backgroundColor: Color.lightGreen,
            animation: `${tease()} 0.3s ease-in-out 0s`,
        },
    }
}

const CheckButton = ({ text, selected, setSelected, disabled, noCheck = false }) => {
    return (
        <Stack direction='row'
            sx={{
                ...styles.container,
                ...(selected && styles.selected),
                ...(disabled && styles.containerDisabled),
            }}
            onClick={() => setSelected(!selected)}
            alignItems='center' justifyContent={noCheck ? 'center' : 'space-between'}
        >
            {!noCheck && <Checkbox disabled={disabled} checked={selected} sx={{ padding: 0 }}
                style={{
                    color: disabled ? 'rgb(122, 122, 104)' : 'black',
                }} />}
            <Box sx={{ ...styles.text }}>
                {text}</Box>
            <Box />
        </Stack>
    )
}
export const CheckButtonStack = ({ data, selected, setSelected, disabled, noCheck = false, extraHoverStyle = '' }) => {
    return (
        <Stack direction='row'
            sx={{
                ...styles.container,
                ...(selected && styles.selected),
                ...(disabled && styles.containerDisabled),
                ...(!selected && extraHoverStyle === 'greenHover' && styles.greenHover),
            }}
            onClick={() => setSelected(!selected)}
            alignItems='center' justifyContent={noCheck ? 'center' : 'space-between'}
        >
            {!noCheck && <Checkbox disabled={disabled} checked={selected} sx={{ padding: 0 }}
                style={{
                    color: disabled ? 'rgb(122, 122, 104)' : 'black',
                }} />}
            <Stack sx={{ ...styles.textStack }} direction='column' spacing={1}>
                <Stack direction='column' spacing={1}>
                    <Box sx={styles.title}>{data.title}</Box>
                    <Box sx={styles.bar} />
                </Stack>
                {data.bullets.map((bullet, index) => {
                    return (<Stack key={index}
                        alignItems='flex-start'
                        // alignItems='center'
                        direction='row' sx={{ ...styles.body, textAlign: 'left', width: '100%' }}>
                        <Box sx={{
                            minWidth: '30px',
                            transform: bullet.iconTransform,
                        }}>
                            {bullet.icon}
                        </Box>{bullet.text}</Stack>
                    )
                })}
            </Stack>
            <Box />
        </Stack>
    )
}

export default CheckButton